import React from "react";
import { CircularProgress, Typography } from "@material-ui/core";

const Loading = () => {
  return (
    <div style={{ textAlign: "center", margin: "2rem" }}>
      <CircularProgress />
      <Typography style={{ marginTop: 8 }} color="textSecondary">
        Loading ...
      </Typography>
    </div>
  );
};

export default Loading;
